<mat-card appearance="outlined" data-tfa="treeview-component_card" id="treeview-component">
    <mat-card-content>
        <div id="treeview-component_header">
            <div class="right-content">
                <div class="zone-ordre"></div>
                <div class="ects">ects</div>
                <div class="obligatoire-facultatif" matTooltip="Obligatoire/facultatif">Obl.</div>
                <div class="mutualise" matTooltip="Mutualisé">Mut.</div>
                <div class="point-IA">PIA</div>
                <div class="valide">Valide</div>
                <div class="menu-button"></div>
            </div>
        </div>
        @if (reorderMode) {
        <lib-pegase-message-contextuel class="reorder-alert" data-tfa="alerte-reordonnancement" [type]="'info'" [closable]="false">
            <div class="reorder-alert-content">
                <div class="reorder-alert-copy">
                    <strong>Réordonnancement actif</strong>
                    <span
                        >Déplacez les enfants directs de {{ reorderMode?.parentCode }}. Chaque déplacement est sauvegardé
                        immédiatement.</span
                    >
                </div>
                <button
                    type="button"
                    mat-stroked-button
                    data-tfa="bouton-quitter-reordonnancement"
                    (click)="quitterModeOrdre()"
                    [disabled]="reorderMode?.enAttente"
                >
                    Quitter
                </button>
            </div>
        </lib-pegase-message-contextuel>
        }
        <cdk-virtual-scroll-viewport
            class="virtual-scroll-container"
            id="treeview_virtual_scroll_container"
            itemSize="26"
            cdkDropList
            (cdkDropListDropped)="drop($event)"
            cdkDropListAutoScrollDisabled="true"
            cdkDropListSortingDisabled="true"
            role="table"
        >
            <ng-container *cdkVirtualFor="let node of dataSource">
                <div
                    tabindex="0"
                    class="node mat-tree-node"
                    cdkDrag
                    cdkDragLockAxis="y"
                    cdkDragBoundary="#treeview_virtual_scroll_container"
                    [cdkDragData]="dragDataObjetMaquette(node)"
                    [cdkDragDisabled]="!isNodeReordonnable(node) || !!reorderMode?.enAttente"
                    (cdkDragStarted)="preparerLignesEnfantsReordonnables()"
                    (cdkDragMoved)="mettreAJourRepereInsertion($event)"
                    (cdkDragEnded)="reinitialiserRepereInsertion()"
                    [class.selected]="node.path === (objetMaquetteSelected$ | async)?.path"
                    [attr.aria-selected]="node.path === (objetMaquetteSelected$ | async)?.path"
                    [class.same-as-selected]="node.id === (objetMaquetteSelected$ | async)?.id"
                    [class.contains-text]="node.containsText"
                    [class.parent-reordonne]="isParentReordonne(node)"
                    [class.reordonnable]="isNodeReordonnable(node)"
                    [class.ordonnancement-en-cours]="!!reorderMode?.enAttente"
                    [class.repere-insertion-avant]="afficherRepereInsertionAvant(node)"
                    [class.repere-insertion-apres]="afficherRepereInsertionApres(node)"
                    [style.--node-indent.px]="node.level * 24 + 12"
                    [class.mandatory]="node.obligatoire"
                    [class.hide-lien]="node.estEnfantDeGroupement"
                    [class.expanded]="flatTreeControl.isExpanded(node)"
                    [class.partie-administrative]="hasPIAInChildren(node)"
                    [class.partie-pedagogique]="node.pia || node.piaPresentSurUnAncetre"
                    [attr.data-level]="node.level"
                    [attr.data-id]="node.id"
                    [attr.data-path]="node.path"
                    [attr.data-reorderable]="isNodeReordonnable(node)"
                    [attr.aria-describedby]="node.containsText ? 'filtrage-resultats-count' : null"
                    (click)="noeud.onSelected()"
                    (keyup.enter)="noeud.onSelected()"
                    role="row"
                >
                    @if (afficherRepereInsertionAvant(node)) {
                    <span class="reorder-insert-line before"></span>
                    } @if (afficherRepereInsertionApres(node)) {
                    <span class="reorder-insert-line after"></span>
                    } @if (node.expandable) {
                    <button
                        mat-icon-button
                        class="tree-node-toggle-button"
                        [attr.data-tfa]="'noeud ' + node.code"
                        [attr.aria-label]="'Toggle ' + node.code"
                        [disabled]="isTreeToggleDisabled(node)"
                        (click)="
                            $event.stopImmediatePropagation();
                            flatTreeControl.isExpanded(node) ? flatTreeControl.collapse(node) : flatTreeControl.expand(node)
                        "
                    >
                        <mat-icon class="mat-icon" data-tfa="iconExpand">
                            {{ flatTreeControl.isExpanded(node) ? 'expand_more' : 'chevron_right' }}
                        </mat-icon>
                    </button>
                    } @else {
                    <div class="button-placeholder"></div>
                    }
                    <app-maquette-noeud
                        #noeud
                        [objetMaquette]="node"
                        [modeOrdre]="!!reorderMode"
                        [reordonnable]="isNodeReordonnable(node)"
                        [ordonnancementEnCours]="!!reorderMode?.enAttente"
                        [parentReordonne]="isParentReordonne(node)"
                        [afficherActionsReordonnancement]="canUseEnfantReorderActions(node)"
                        [afficherActionModifierOrdreEnfants]="canModifierOrdreEnfants(node)"
                        [peutPlacerAuDebut]="canMoveEnfantToDebut(node)"
                        [peutMonter]="canMoveEnfantToPrevious(node)"
                        [peutDescendre]="canMoveEnfantToNext(node)"
                        [peutPlacerALaFin]="canMoveEnfantToFin(node)"
                        [attr.data-id]="node.id"
                        [attr.data-path]="node.path"
                        (detached)="retirerEnfant($event)"
                        (supprime)="supprimer($event)"
                        (rendreObligatoire)="modifierLien($event, true)"
                        (rendreFacultatif)="modifierLien($event, false)"
                        (pointInscriptionAdministrativeToggle)="node.pia ? retirerPIA($event) : ajouterPIA($event)"
                        (openAllNodesOfSameDepth)="expandAllAtNodeLevel(node)"
                        (modifierOrdreEnfants)="basculerModeOrdre($event)"
                        (placerEnfantAuDebut)="placerEnfantAuDebut($event)"
                        (monterEnfant)="monterEnfant($event)"
                        (descendreEnfant)="descendreEnfant($event)"
                        (placerEnfantALaFin)="placerEnfantALaFin($event)"
                    ></app-maquette-noeud>
                    @if (node.path === (objetMaquetteSelected$ | async)?.path) {
                    <ng-container *ngTemplateOutlet="linksButtons; context: { node }"></ng-container>
                    }
                </div>
            </ng-container>
        </cdk-virtual-scroll-viewport>
    </mat-card-content>
</mat-card>

<ng-template #linksButtons let-node="node">
    @if (node.id !== (racine$ | async)?.id) {
    <button
        [routerLink]="'../' + node.id"
        [attr.data-tfa]="'bouton-lien_' + node.id"
        mat-mini-fab
        matTooltip="ouvrir dans l'éditeur"
        class="goto-link-button"
    >
        <mat-icon [attr.data-tfa]="'icone-lien_' + node.id">open_in_browser</mat-icon>
    </button>
    }
</ng-template>
